import React, { useEffect, useState } from "react";
import { useApp } from "../context/AppContext";
import { useI18n } from "../context/I18nContext";
import { hasAdConsent, saveAdConsent } from "../utils/adConsent";

export default function AdConsentBanner() {
  const { state } = useApp();
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!state.settings) return;
    setVisible(!hasAdConsent(state.settings));
  }, [state.settings]);

  const accept = (choice) => {
    saveAdConsent(choice);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="ad-consent-banner">
      <div>
        <strong>{t("adConsentTitle")}</strong>
        <span>{t("adConsentText")}</span>
      </div>
      <div className="ad-consent-actions">
        <button className="btn btn-outline btn-sm" onClick={() => accept("non_personalized")}>{t("acceptNonPersonalizedAds")}</button>
        <button className="btn btn-primary btn-sm" onClick={() => accept("personalized")}>{t("acceptPersonalizedAds")}</button>
      </div>
    </div>
  );
}
